import { SET_MONITOR_USERS } from "./mutation-types";

const mutations = {
  [SET_MONITOR_USERS](state, users) {
    state.users = users;
  },
};

export default mutations;
